<template>
<main class="sa-content">
    <div class="sa-card-large">
        <div class="sa-mob-header sa-mb20">
            <h5 class="sa-card-tit">{{diagnosis}} diagnosis</h5>
            <span class="sa-btn-back" @click="goBack()">
                <i class="icon-arrow-left"></i>
            </span>
        </div>
        <div class="sa-mob-cont sa-mob-cont-padbt">
            <div v-for="(n, i) of problems" :key="i" class="sa-card sa-card-gray sa-card-noshadow">
                <div class="sa-word-break" @click="openToggle(i)">
                    {{ n.problem }}
                    <span :class="{'icon-plus sa-added-med': !open[i],'icon-minus sa-added-med': open[i],}" class="sa-sec-icon"></span>
                </div>
                <transition>
                    <div class="sa-pre-acc-cnt" v-show="open[i]">
                        <label>Problem</label>
                        <span>{{ n.problem }}</span>
                        <label>Onset</label>
                        <span>{{ n.onset }}</span>
                        <label>Problem Note</label>
                        <span>{{ n.problem_note }}</span>
                        <a v-if="n.created_by == userDetails.uid" @click="removeProblem(n.prb_id)" class="sa-red-text sa-text-underline">Remove diagnosis</a>
                        <a v-else-if="n.cid == userDetails.uid" @click="removeData(n)" class="sa-red-text sa-text-underline">Remove diagnosis</a>
                    </div>
                </transition>
            </div>
            <div class="sa-card sa-card-gray sa-card-noshadow">
                <div class="sa-row">
                    <div class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg4">
                        <div class="sa-form-group">
                            <label>Select Problem<span class="sa-red-text">*</span></label>
                            <i class="icon-down-arrow sa-form-icon"></i>
                            <input type="text" class="sa-form-control sa-cursor sa-form-ellipsis" @click="slctProb = !slctProb" v-model="data.problem" placeholder="Select" @input="event => searchProblem(event)" @change="changeType" />
                            <div class="sa-slct-prob" v-if="slctProb" @click.self="slctProb = false">
                                <ul class="sa-infinite-list">
                                    <li v-for="(item, index) in medicalProblems" :key="index" class="sa-infinite-list-item" @click="getItem(item.desc)">{{ item.desc }}</li>
                                </ul>
                                <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler" spinner="waveDots"></infinite-loading>
                            </div>
                        </div>
                    </div>
                    <div class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg4">
                        <div class="sa-form-group">
                            <label>Onset</label>
                            <i class="icon-picker sa-form-icon sa-f-size16"></i>
                            <!-- <span class="sa-edit-date"> -->
                            <vc-date-picker :max-date="new Date()" v-model="data.onset" class="sa-mob-cal" :masks="masks">
                                <input id="date" name="date" readonly slot-scope="{ inputProps, inputEvents, isDragging }" type="input" v-bind="inputProps" class="sa-form-control" />
                            </vc-date-picker>
                            <!-- </span> -->
                        </div>
                    </div>
                    <div class="sa-col-lg12">
                        <div class="sa-card">
                            <span class="sa-darkblue-text el-avatar">Problem Note</span>
                            <input class="sa-textarea" placeholder="Add here" rows="1" v-model="data.problem_note" name="summary note" id="summaryNote" />
                        </div>
                    </div>
                    <div class="sa-col-xs12 sa-col-sm5 sa-col-md4 sa-col-lg3 sa-mb10">
                        <input type="checkbox" id="problem" v-model="data.addProblem" name="problem" />
                        <label for="problem">Add to Problem list</label>
                    </div>
                    <div class="sa-col-xs12 sa-col-sm5 sa-col-md4 sa-col-lg3">
                        <input type="checkbox" id="Allergy" v-model="data.addAllergy" name="allergy" />
                        <label for="Allergy">Add to Allergy list</label>
                    </div>
                </div>

            </div>
            <a @click="addProblem()" class="sa-blue-text sa-text-underline">Add Problems</a>
            <div class="sa-ftr-btn">
                <button @click="saveProblem()" class="sa-btn sa-btn-large sa-btn-block-xs sa-btn-primary">Save</button>
            </div>
        </div>
    </div>
</main>
</template>

<script>
import {
    pro_url,
    chs_url
} from "../../../../config/endpoints";
import moment from "moment";
import _ from "lodash";
import InfiniteLoading from "vue-infinite-loading";

export default {
    components: {
        "infinite-loading": InfiniteLoading,
    },
    data() {
        return {
            waitInQueue: false,
            pageData: {
                "limit": 10,
                "page": 1
            },
            slctProb: false,
            infiniteId: +new Date(),
            masks: {
                input: 'DD-MM-YYYY'
            },
            prbDataCheck: false,
            ref_id: null,
            diagnosis: null,
            emits: ["close"],
            checked: false,
            i: null,
            open: {},
            open1: {},
            problemCheck: false,
            // uid: null,
            userDetails: null,
            // icdlist: null,
            medicalProblems: [],
            data: {
                addProblem: false,
                addAllergy: false,
                problem: ""
            },
            problems: [],
            problemData: [],
        };
    },
    watch: {
        "data.onset": {
            // immediate: true,
            deep: true,
            handler(val) {
                let dd = moment().format("HH:mm:ss")
                let dt = moment(val).format("YYYY-MM-DD")
                // this.data.onset = dt + ' ' + dd
            }
        }
    },
    methods: {
        hide() {
            this.slctProb = false
        },
        removeProblem(prb_id) {
            let _self = this
            _self.$store
                .dispatch("httpPost", {
                    uri: `${pro_url}/problem/delete`,
                    body: {
                        prb_id: prb_id,
                    },
                })
                .then((response) => {
                    if (response && response.status === 1000) {
                        _self.$store.dispatch("SET_ALERTMESSAGE", {
                            msg: "problem deleted successfully. Loading problem list",
                            class: "sa-a-success",
                        });
                        _self.getProblems();
                    } else {
                        _self.$store.dispatch("SET_ALERTMESSAGE", {
                            msg: "problem not deleted check with operation team",
                            class: "sa-a-danger",
                        });
                    }
                })
        },
        goBack: function () {
            // webview back button
            if (typeof window != undefined && window.ReactNativeWebView) {
                let data = {
                    action: "end",
                };
                window.ReactNativeWebView.postMessage(JSON.stringify(data));
            } else {
                this.$router.go(-1)
            }
        },
        backAction: function () {
            this.$router.push(
                "/appointments/doctor-details/add-diagnosis/" + this.$route.params.appid
            );
        },
        openToggle(i) {
            let _self = this;
            let flag = !_self.open[i];
            _self.$set(_self.open, i, flag);
            _self.presDiag += 1
        },
        saveProblem() {
            let _self = this;
            _.map(_self.problems, e => {
                if (_self.data.problem == e.problem) {
                    _self.$store.dispatch("SET_ALERTMESSAGE", {
                        msg: "Please add new diagnosis, the dignosis already added",
                        class: "sa-a-danger",
                    });
                    _self.data = {
                        addProblem: false,
                        addAllergy: false,
                    };
                    return e
                } else {
                    return e
                }
            })
            if (_self.data && _self.data.problem) {
                let Patient = {
                    createdby: _self.userDetails.uid,
                    ref_id: _self.ref_id,
                    // usr_rel_id: _self.uid,
                    prb_note: _self.data.problem_note,
                    onset: _self.data.onset,
                    allergy: _self.data.addAllergy,
                    problem_list: _self.data.addProblem,
                    icd10_code: _self.data.problem.split("(")[0],
                    diagnosis: _self.diagnosis,
                    problem: _self.data.problem,
                };
                _self.problemData.push(Patient);
                _self.data = {
                    test: true,
                    addProblem: false,
                    addAllergy: false,
                };
                _self.$store
                    .dispatch("httpPost", {
                        uri: `${pro_url}/addProblems`,
                        body: _self.problemData,
                    })
                    .then((response) => {
                        _self.problemData = []
                        _self.loader = false;
                        if (window.ReactNativeWebView) {
                            let data = {
                                action: "complete",
                            };
                            window.ReactNativeWebView.postMessage(JSON.stringify(data));
                        } else {
                            _self.$router.push({
                                path: '/appointments/doctor-details/add-diagnosis/' + _self.$route.params.appid
                            })
                        }
                    });
            } else if (_self.problemData && _self.problemData.length && _self.prbDataCheck) {
                let data = _self.problemData
                _self.problemData = []
                _self.$store
                    .dispatch("httpPost", {
                        uri: `${pro_url}/addProblems`,
                        body: data,
                    })
                    .then((response) => {
                        _self.problemData = []
                        _self.loader = false;
                        if (window.ReactNativeWebView) {
                            let data = {
                                action: "complete",
                            };
                            window.ReactNativeWebView.postMessage(JSON.stringify(data));
                        } else {
                            _self.$router.push({
                                path: '/appointments/doctor-details/add-diagnosis/' + _self.$route.params.appid
                            })
                        }
                    });
            } else {
                if (_self.data && _self.data.problem) {
                    if (window.ReactNativeWebView) {
                        let data = {
                            action: "complete",
                        };
                        window.ReactNativeWebView.postMessage(JSON.stringify(data));
                    } else {
                        _self.$router.push({
                            path: '/appointments/doctor-details/add-diagnosis/' + _self.$route.params.appid
                        })
                    }
                } else if (!_self.prbDataCheck && !_self.data.test) {
                    _self.$store.dispatch("SET_ALERTMESSAGE", {
                        msg: "Please add atleast one new diagnosis",
                        class: "sa-a-danger",
                    });
                }

            }

        },
        removeData(n) {
            let ref = this.problems.find(f => n.problem == f.problem)
            let dt = this.problems.indexOf(ref)
            let Patient = {
                createdby: this.userDetails.uid,
                ref_id: this.ref_id,
                // usr_rel_id: this.uid,
                prb_note: ref.problem_note,
                onset: ref.onset,
                allergy: ref.addAllergy,
                problem_list: ref.addProblem,
                icd10_code: ref.problem.split("(")[0],
                diagnosis: this.diagnosis,
            };
            let dx = this.problemData.find(f => Patient.icd10_code == f.icd10_code)
            let dm = this.problemData.indexOf(dx)
            this.problems.splice(dt, 1)
            this.problemData.splice(dm, 1)

        },
        addProblem() {
            if (this.data && this.data.problem) {
                this.data.cid = this.userDetails.uid
                _.map(this.problems, e => {
                    if (this.data.problem == e.problem) {
                        this.$store.dispatch("SET_ALERTMESSAGE", {
                            msg: "Please add new diagnosis, the dignosis already added",
                            class: "sa-a-danger",
                        });
                        this.data = {
                            addProblem: false,
                            addAllergy: false,
                        };
                        return e
                    } else {
                        return e
                    }
                })
                if (this.data && this.data.problem) {
                    this.data.onset1 = this.data.onset
                    this.prbDataCheck = true
                    this.data.onset = moment(this.data.onset).format("DD-MM-YYYY")
                    this.problems.push(this.data);
                    let Patient = {
                        createdby: this.userDetails.uid,
                        ref_id: this.ref_id,
                        // usr_rel_id: this.uid,
                        prb_note: this.data.problem_note,
                        onset: this.data.onset1,
                        allergy: this.data.addAllergy,
                        problem_list: this.data.addProblem,
                        icd10_code: this.data.problem.split("(")[0],
                        diagnosis: this.diagnosis,
                    };
                    this.problemData.push(Patient);
                    this.data = {
                        addProblem: false,
                        addAllergy: false,
                    };
                }

            } else {
                this.$store.dispatch("SET_ALERTMESSAGE", {
                    msg: "Please add Problem",
                    class: "sa-a-danger",
                });
            }
        },
        
        infiniteHandler($state) {
            if ($state) {
                let _self = this
                if(_self.data.problem) {
                    _self.pageData.desc = _self.data.problem
                } else {
                    _self.pageData.desc = ''
                }
                _self.waitInQueue = true
                _self.$store.dispatch("httpPost", {
                        uri: `${pro_url}/medicalProblemsv1`,
                        body: {
                            page: _self.pageData.page,
                            limit: _self.pageData.limit,
                            desc: _self.pageData.desc
                        }
                    }).then((response) => {
                        _self.waitInQueue = false
                        if (response && response.status === 1000 && response.data && response.data.data && response.data.data.length) {
                            _self.pageData.page += 1
                            _self.medicalProblems.push.apply(_self.medicalProblems, response.data.data)
                            if ($state!=1) {
                                $state.loaded()
                            }
                        } else {
                            if ($state!=1) {
                                $state.complete()
                            }
                        }
                    })
                    .catch((e) => {
                        console.log(e)
                    });
            }
        },
        changeType() {
            this.pageData.page = 1;
            // this.medicalProblems = [];
            this.infiniteId += 1;
        },
        getItem(val) {
            this.data.problem = val
            this.slctProb = false
        },
        searchProblem: function () {
            let _self = this
            if (this.data.problem.length > 2 || this.data.problem.length == 0) {
                if (this.waitInQueue) {
                    setTimeout(function(){
                        _self.searchProblem()
                    }, 500)
                } else {
                    this.pageData.page = 1
                    this.medicalProblems = []
                    this.infiniteId += 1;
                    this.infiniteHandler()
                }
            }
        },
        // getMedicalProblems(){
        //         let _self = this
        //         _self.$store.dispatch("httpPost", {
        //                 uri: `${chs_url}/bupa/medicalProblems`,
        //                 body: {
        //                     page: _self.pageData.page,
        //                     limit: _self.pageData.limit
        //                 }
        //             }).then((response) => {
        //                 if (response && response.status === 1000) {
        //                     _self.pageData.page += 1
        //                     _self.medicalProblems.push(response.data)
        //                 }
        //             })
        //             .catch((e) => {
        //                 console.log(e)
        //             });
        // },
        getProblems() {
            let _self = this;
            _self.$store
                .dispatch("httpPost", {
                    uri: `${pro_url}/problems`,
                    body: {
                        ref_id: _self.ref_id,
                        assesment: _self.diagnosis,
                    },
                })
                .then((response) => {
                    _self.loader = false;
                    if (response && response.status === 1000) {
                        _self.problems = response.data;
                        // _self.uid = response.data[0].usr_rel_id;
                    } else {
                        _self.problems = []
                    }
                });
        },
    },
    mounted() {
        this.ref_id = this.$route.query.ref_id;
        this.diagnosis = this.$route.query.diagnosis;
        this.userDetails = JSON.parse(this.$localStorage.get("userdata"));
        this.getProblems();
        this.infiniteHandler();
    },
};
</script>

<style>
.sa-pre-acc-cnt {
    padding-top: 20px
}
</style>
